import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import { LocationDetailsMap } from 'src/locations/LocationDetailsMap';
import { NoLocation } from 'src/locations/NoLocation';
import { fetchSimInventoryEntry } from 'src/simInventory/SimInventoryApi/simInventoryApi';

type SimLocationDetailsMapProps = {
  iccid: string;
};

export const SimLocationDetailsMap: FC<SimLocationDetailsMapProps> = (props) => {
  const { iccid } = props;

  const { data, status, fetchStatus } = useQuery({
    queryKey: ['locations', 'map', 'sim-imsi', iccid],
    queryFn: async ({ signal }) => {
      return fetchSimInventoryEntry(iccid, undefined, signal);
    },
    enabled: !!iccid,
    meta: {
      isLocationsDetails: true,
    },
  });

  const parentInitialPending = status === 'pending' && fetchStatus === 'fetching';
  const parentError = status === 'error';

  if (status === 'success' && !data.imsi) {
    return <NoLocation />;
  }

  return (
    <LocationDetailsMap
      imsi={data?.imsi ?? ''}
      parentInitialPending={parentInitialPending}
      parentError={parentError}
    />
  );
};
